import { Edit } from "lucide-react";
import { AlertType, IntegrationType, OriginFile, QuotaUserStatus, TypeLayout } from "../constants/enums";
import { iProComponent, iProIntegration, iProProjectMain } from "../models/interfaceProject";
import { iSaveMain } from "../models/interfaceSaveMain";
import { getChangeName, getUsedProjectCuota } from "./functions";
import { getDefaultProProjectMain } from "../constants/defaultValue";
import { iQuotaUser } from "../models/interfaceQuotaConfiguration";
import { iUserLoginInfo } from "../models/interfaceUserLogin";
 

export function mapProProjectToSaveMain(proProject: iProProjectMain, formSchemaJson: iProComponent[],user:any ): FormData {
  console.log("mapProProjectToSaveMain", proProject, formSchemaJson)
  const formData = new FormData(); 
  if(proProject.datacenter){
    if(proProject.datacenter.files){
      proProject.datacenter.files.forEach((fileData, index) => {
        if(fileData.file){
            formData.append(fileData.name??"", fileData.file); 
        } else{ 
            //throw new Error(`no se ha encontrado archivo en : ${fileData.name}`);
        } 
      });
    }
    if(proProject.datacenter.documents_file){
      proProject.datacenter.documents_file.forEach((fileData, index) => {
        if(fileData.file){
            formData.append(fileData.name??"", fileData.file); 
        } else{ 
            //throw new Error(`no se ha encontrado archivo en : ${fileData.name}`);
        } 
      });
    } 
  }

  const project = {
    domain: proProject.project.domain,
    project: {
      id:proProject.project.id,
      deployed: proProject.project.deployed,
      cloud_resource: proProject.project.cloud_resource,
      chatbot_type: proProject.project.chatbot_type,
      icono: proProject.project.icono,
      icono_bot: proProject.project.icono_bot,
      alias:proProject.project.alias,
      view_id:proProject.project.view_id,
      view_name:proProject.project.view_name,
      // chatbot: proProject.project.chatbot,
      components:proProject.project.chatbot_type === TypeLayout.Personal?[]:(formSchemaJson??[]),
      env:proProject.project.env,
      monitor: {
      development: {
        total_cost: proProject.project.monitor.development.total_cost,
        total_questions: proProject.project.monitor.development.total_questions,
        total_tokens: proProject.project.monitor.development.total_tokens,
        count_users: proProject.project.monitor.development.count_users,          
      }
      },
      version_metadata:{
      prompt_params:{
        assistant_name: proProject.config.prompt_params.assistant_name,
        assistant_role: proProject.config.prompt_params.assistant_role,
        company_name: proProject.config.prompt_params.company_name,
        company_activity: proProject.config.prompt_params.company_activity,          
        conversation_purpose: proProject.config.prompt_params.conversation_purpose,
        welcome_message: proProject.config.prompt_params.welcome_message,
        alias: proProject.config.prompt_params.alias
      },        
      config_params:{
        provider: proProject.config.config_params.provider,
        model_type: proProject.config.config_params.model_type,
        temperature: proProject.config.config_params.temperature,
        model_name: proProject.config.config_params.model_name,
        k_top_retrieval: proProject.config.config_params.k_top_retrieval,
        max_token_history: proProject.config.config_params.max_token_history,
        k_top_history: proProject.config.config_params.k_top_history,
        max_minutes: proProject.config.config_params.max_minutes
      },
      tags: []
      },
      project_name: proProject.config.prompt_params.assistant_name, 
      business_case: proProject.project.business_case,      
      description: proProject.project.description, 
      // connections: proProject.project.connections,
      private_access: proProject.project.private_access,//proProject.project.permissions.filter(O=>!O.deleted)?.length>0?true:false,
      loggin_disabled: proProject.project.loggin_disabled,
      generic_access: proProject.project.generic_access,
      generic_access_detail: proProject.project.generic_access_detail,
      // generic_access_detail: proProject.project.generic_access_detail,
      //permissions: proProject.project.private_access ? proProject.project.
      permissions:proProject.project.permissions??[],
      chpro_integrations:proProject.project.chpro_integrations.filter(O=>O.edit),//.map(doc => ({...doc, edit:doc.id?doc.edit:false}))
      evaluation:{
                    active:(proProject.project.evaluation?.metrics ?? []).length > 0,
                    metrics:proProject.project.evaluation?.metrics??[],
                    extra_params:proProject.project.evaluation?.extra_params??{} 
                  },
      // quota:321, 
      // groups: iQuotaGroups[];
      quota: proProject.project.quota,
      usuarios_to_create: filterUsars(proProject.project.users,QuotaUserStatus.New),
      usuarios_to_delete: filterUsars(proProject.project.users,QuotaUserStatus.Deleted),
      usuarios_to_update: filterUsars(proProject.project.users,QuotaUserStatus.Updated),
      groups: proProject.project.groups,
      notifications:proProject.project.notifications?.map(notif=>({
        id:notif.id,
        title:notif.title,
        body:notif.body,
        link:notif.link,
        expiration_date:notif.expiration_date
      }))
  },
  datacenter: {
    //embedding: proProject.datacenter?.embedding ?? "",
    //embedding_source: proProject.datacenter?.embedding_source??"",
    //database_service: proProject.datacenter?.database_service??"",
    datacenter_id:proProject.project.id ? proProject.config.datastores[0].datacenter_id:null,
    documents_file_flag: proProject.datacenter?.documents_file_flag??false,
    name: proProject.config.prompt_params.assistant_name, // Se toma del nombre del proyecto
    database_service_id: proProject.project.id && proProject.config.datastores[0].database_service_id ? proProject.config.datastores[0].database_service_id:getChangeName(proProject,user) , //`inca-ai-${proProject.project.project_name}`, // Generado con el nombre del proyecto ----> cambiar en caso de editar 
    description: proProject.project.description, // Valor por defecto si no está en `iProProjectMain`
    actual_documents_file_id:proProject.datacenter?.documents_file?.[0]?.actual_documents_file_id,
    env:proProject.project.env,
    
    //------------------------------------------------------------------
    drive_files: proProject.datacenter?.files?.filter(O=>O.file_origin==OriginFile.Drive).map(doc => ({
      file_id:proProject.project.id?doc.file_id:null,
      chunk_overlap: doc.chunk_overlap, //
      chunk_size: doc.chunk_size, // 
      file_type: doc.file_type,//
      file_size: doc.file_size,//
      type: doc.type,//
      name: doc.name,//
      columns: doc.columns, //XLS
      embedded_column: doc.embedded_column,//XLS       
      file_origin:doc.file_origin,
      drive_id:doc.drive_id,
      drive_mime_type:doc.drive_mime_type,
      drive_version: doc.drive_version,
      drive_modified_time: doc.drive_modified_time,
      drive_url: doc.drive_url,
      
      deleted: doc.deleted,
      created: doc.created,
      updated: doc.updated
    })) ?? [],  
    ///-----------------------------------------------------------------
    files: proProject.datacenter?.files?.filter(O=>O.file_origin!=OriginFile.Drive).map(doc => ({
      file_id:proProject.project.id?doc.file_id:null,
      chunk_overlap: doc.chunk_overlap, //
      chunk_size: doc.chunk_size, // 
      file_type: doc.file_type,//
      file_size: doc.file_size,//
      type: doc.type,//
      name: doc.name,//
      columns: doc.columns, //XLS
      embedded_column: doc.embedded_column,//XLS 
      deleted:proProject.project.id?doc.deleted:false,    
      
      file_origin:doc.file_origin,
      drive_id:doc.drive_id,
      drive_mime_type:doc.drive_mime_type,
      drive_version: doc.drive_version,
      drive_modified_time: doc.drive_modified_time,
      drive_url: doc.drive_url,    
    })) ?? [],
    qa:proProject.qa?.map(q => ({ 
      qa_id:q.qa_id,
      chunk_overlap: q.chunk_overlap,
      chunk_size: q.chunk_size,
      question: q.question,
      answer: q.answer,
      deleted: q.deleted,
      edit: q.edit,
    })) ??[],
    documents_file: proProject.datacenter?.documents_file?.map(doc => ({
      chunk_overlap: doc.chunk_overlap, //
      chunk_size: doc.chunk_size, // 
      file_type: doc.file_type,//
      file_size: doc.file_size,//
      type: doc.type,//
      name: doc.name,//
      columns: doc.columns //XLS  
    })) ?? [], 
    deleted_qa:proProject.datacenter?.deleted_qa
  },

  };

  formData.append(`data`, JSON.stringify(project)); 
  
  return formData;
 
  
}


export function mapProProjectToSavePublish(proProject: iProProjectMain, user:any ):any {
  const project = {
    domain: proProject.project.domain, //
    project_id:proProject.project.id, // 
    created_user:user.email
  } 
  return project; 
}




export function filterUsars(users:iQuotaUser[], filterStatus:QuotaUserStatus){
  return users.filter(O=>O.status=== filterStatus).map(user=>({
        user: user.user,
        quota: user.quota
      }))??[]
};


export function validateProject(
  vProject: iProProjectMain, 
  userLoginInfo:iUserLoginInfo,
  addAlert: (message: string, type: AlertType) => void
): boolean {  
  let isValid = true; 
  const inical = getDefaultProProjectMain(vProject.project.chatbot_type,vProject.project.env);
  if(!vProject.project.id&&vProject.config.prompt_params.assistant_name == inical.config.prompt_params.assistant_name){
    addAlert(`Establece un nombre para tu asistente`, AlertType.Error);
    return false;
  }

  const domainQuota = vProject?.project?.quota_config?.domain_quota ?? 0;
  const totalProjectQuota = vProject?.project?.quota_config?.total_quota_project_domain ?? 0;
  const maxQuotaAllowed = domainQuota - totalProjectQuota;
  if (0 > maxQuotaAllowed) {
      addAlert(`La quota de la organización es de $${domainQuota.toFixed(2)}, pero ya se han asignado $${totalProjectQuota.toFixed(2)} a otros proyectos. No puedes asignar más quota.`, AlertType.Error);
      return false
  }

  const usedQuotas = getUsedProjectCuota(vProject)
  if(vProject.project.quota < usedQuotas){
    addAlert(`La cuota debe ser mayor o igual a la suma de las cuotas asignadas a usuarios y grupos ($ ${usedQuotas}).`, AlertType.Error);
    return false;
  }  

  return isValid;

  

}



export function validateChproIntegrations(
  integrations: iProIntegration[], 
  addAlert: (message: string, type: AlertType) => void
): boolean {
  
  let isValid = true; 
  integrations.forEach((integration, index) => {
    if (integration.active && integration.edit) {
      switch (integration.type) {
        case IntegrationType.Whatsapp:
          if (!integration.account_id) {
            addAlert(`Falta el campo "Cuenta" en la integración de WhatsApp`, AlertType.Warning);
            isValid = false;
          }
          if (!integration.graph_api_token) {
            addAlert(`Falta el campo "Graph API Token" en la integración de WhatsApp`, AlertType.Warning);
            isValid = false;
          }
          break;

        case IntegrationType.Azure_bot:
          if (!integration.account_id) {
            addAlert(`Falta el campo "Cuenta" en la integración de Azure Bot`, AlertType.Warning);
            isValid = false;
          }
          if (!integration.app_id) {
            addAlert(`Falta el campo "App Id" en la integración de Azure Bot`, AlertType.Warning);
            isValid = false;
          }
          if (!integration.secret) {
            addAlert(`Falta el campo "Secreto" en la integración de Azure Bot`, AlertType.Warning);
            isValid = false;
          }
          break;

        case IntegrationType.Supplier:
          if (!integration.account_id) {
            addAlert(`Falta el campo "Cuenta" en la integración de Proveedor`, AlertType.Warning);
            isValid = false;
          }
          break;
        case IntegrationType.Embed:

          break;

        default:
          addAlert(`Falta el tipo en la integración`, AlertType.Warning);
          isValid = false;
      }
    }
  });

  return isValid;
}


export function generateFormData(data: Record<string, any>): FormData {
  const formData = new FormData();
  Object.entries(data).forEach(([key, value]) => {
    if (value !== undefined && value !== null) formData.append(key, value);
  });
  return formData;
};